module.exports = __webpack_public_path__ + "static/6305-woodrose-1-5477db42ecb0cde70711ad7ba9cd51bc.jpg";